module.exports = (__webpack_require__("49fU"))(165);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/webpack/buildin/global.js from dll-reference vendor_library
// module id = DuR2
// module chunks = 23